import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getCurrentUser = async () => {
  try {
    const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
    return data;
  } catch {
    return null;
  }
};

export const signInWithGoogle = (returnPath = "/account") => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + returnPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const signOut = async () => {
  try {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
  } catch {
    /* ignore */
  }
};
